export const MY_PRIZES_SECTION = "COMMUNITY_PRIZES";

const VALID_BACK_SECTIONS = new Set(["TOURNAMENTS", "COMMUNITY"]);

export function normalizeMyPrizesBackSection(section) {
  return VALID_BACK_SECTIONS.has(section) ? section : null;
}

export function openMyPrizesNavigation(backSection = null) {
  return {
    homeSection: MY_PRIZES_SECTION,
    backSection: normalizeMyPrizesBackSection(backSection),
  };
}

export function closeMyPrizesNavigation(backSection = null) {
  return {
    homeSection: normalizeMyPrizesBackSection(backSection),
    backSection: null,
  };
}
